// NOTE: Make sure you add any ENV variables you add here to app/views/layouts/shared/_env.html.erb
interface Env {
  GOOGLE_CLIENT_ID: string;
  IMGIX_ENV: string;
  IMGIX_URL: string;
  READ_ONLY_MODE: string;
  READ_ONLY_PHRASE: string;
  READER_URL: string;
  RAILS_ENV: string;
  RECAPTCHA_SITE_KEY: string;
  SHOW_MODAL_ON_INACTION_SECONDS: string;
  STRIPE_PUBLISH_KEY: string;
  SUBSCRIPTIONS_URL: string;
}

declare global {
  interface Window {
    env: Env;
    google: any; // turn off type checking for google sign-in
    createLeadWithGoogle: any; // turn off type checking for google sign-in
    unlockContentWithGoogle: any; // turn off type checking for google sign-in
  }
}

export const GOOGLE_CLIENT_ID: string | null = window?.env?.GOOGLE_CLIENT_ID;
export const IMGIX_ENV: string | null = window?.env?.IMGIX_ENV || window?.env?.RAILS_ENV;
export const IMGIX_URL: string | null = window?.env?.IMGIX_URL;
export const READ_ONLY_MODE: string | null = window?.env?.READ_ONLY_MODE;
export const READ_ONLY_PHRASE: string | null = window?.env?.READ_ONLY_PHRASE;
export const READER_URL: string | null = window?.env?.READER_URL;
export const RECAPTCHA_SITE_KEY: string = window?.env?.RECAPTCHA_SITE_KEY;
export const SHOW_MODAL_ON_INACTION_SECONDS: number = parseInt(
  window?.env?.SHOW_MODAL_ON_INACTION_SECONDS || '31000'
);
export const STRIPE_PUBLISH_KEY: string | null = window?.env.STRIPE_PUBLISH_KEY;
export const SUBSCRIPTIONS_URL: string | null = window?.env.SUBSCRIPTIONS_URL;
